import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, InputGroup, Form, Panel } from 'react-bootstrap';
import _ from 'lodash';
import AutoComplete from './AutoComplete';
import Select from './Select';
import TextInput from './TextInput';
import Button from './Button';

const getLowercaseField = (master_table, table, name) => {
    if (master_table === 'client') {
        return `lower(${master_table}.body->>'${name}')`;
    }

    return `lower(${master_table}.body->'${table}'->>'${name}')`;
};

const DATE_FORMAT = 'MM/DD/YYYY'; // process.env.DATE_FORMAT;
const getDateFormat = (type) => {
    if (type === 'Date' || type === 'DateTime') {
        return DATE_FORMAT;
    } else {
        return undefined;
    }
}

export const comparisonTypes = [{
    label: 'Contains',
    value: '~',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(`%${value}%`);
        return `(trim(both from (${getLowercaseField(master_table, table, name)})) similar to $${params.length})`;
    }

}, {
    label: 'Doesn\'t Contain',
    value: '!~',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(`%${value}%`);
        return `(trim(both from (${getLowercaseField(master_table, table, name)})) not similar to $${params.length})`;
    }
}, {
    label: 'Equals',
    value: '=',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') = to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int >= $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) = $${params.length})`;
    }
}, {
    label: 'Doesn\'t Equal',
    value: '!=',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') != to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int >= $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) != $${params.length})`;
    }
}, {
    label: 'Is Empty',
    value: '_',
    db: (master_table, params, type, table, name, value) => {
        if (master_table === 'client') {
            return `(not(${master_table}.body ? '${name}') or ${master_table}.body->>'${name}' = '')`;
        }

        return `(not(${master_table}.body->'${table}' ? '${name}') or ${master_table}.body->'${table}'->>'${name}' = '')`;
    }
}, {
    label: 'Is Not Empty',
    value: '!_',
    db: (master_table, params, type, table, name, value) => {
        if (master_table === 'client') {
            return `(${master_table}.body ? '${name}' and ${master_table}.body->>'${name}' != '')`;
        }

        return `(${master_table}.body->'${table}' ? '${name}' and ${master_table}.body->'${table}'->>'${name}' != '')`;
    }
}, {
    label: '>',
    value: '>',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') > to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int > $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) > $${params.length})`;
    }
}, {
    label: '>=',
    value: '>=',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') >= to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int >= $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) >= $${params.length})`;
    }
}, {
    label: '<',
    value: '<',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') < to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int < $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) < $${params.length})`;
    }
}, {
    label: '<=',
    value: '<=',
    db: (master_table, params, type, table, name, value) => {
        value = value.trim().toLowerCase();
        params.push(value);
        if (type === 'Date' || type === 'DateTime') {
            const dateFormat = getDateFormat(type);
            return `(to_date(${getLowercaseField(master_table, table, name)}, '${dateFormat}') <= to_date($${params.length}, '${dateFormat}'))`;
        } else if (type === 'Cash') {
            return `((${getLowercaseField(master_table, table, name)})::int <= $${params.length})`;
        }

        return `(trim(both from (${getLowercaseField(master_table, table, name)})) <= $${params.length})`;
    }
}];

class FilterSearchField extends PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.updateComponentFromProps = this.updateComponentFromProps.bind(this);
        this.state = {
            field: undefined,
            operation: undefined,
            value: undefined,
            filter: undefined
        };
    }

    updateComponentFromProps(props) {
        if (props.filter && props.workflowFields) {
            let filter = props.filter;
            let field = props.workflowFields.find(f => {
                return f.name == filter.left;
            });

            if (field) {
                field = field.label;

            } else {
                field = '';
            }

            let operation = comparisonTypes.find(op => {
                return op.value == filter.operator;
            });

            if (operation) {
                operation = operation.value;

            } else {
                operation = '';
            }

            let value = filter.right;
            if (!value) {
                value = '';
            }

            this.setState({
                filter,
                field,
                operation,
                value
            });
        }
    }

    componentDidMount() {
        this.updateComponentFromProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        this.updateComponentFromProps(nextProps);
    }

    onChange(type, value) {
        let filter = {...this.state.filter};
        switch (type) {
        case 'field':
            this.setState({field: value});
            filter['left'] = value ? value.name : '';
            break;

        case 'operation':
            let operationLabel = comparisonTypes.find(op => {
                return op.value == value;
            });

            if (operationLabel) {
                operationLabel = operationLabel.value;
            }

            this.setState({operation: operationLabel});
            filter['operator'] = value;
            break;

        case 'value':
            this.setState({value});
            filter['right'] = value;
            break;

        default:
            return;
        }

        this.setState({filter});
        this.props.changeAction(this.props.rowIndex, filter);
    }

    render() {
        const {
            rowIndex,
            loading,
            deleteAction,
            addAction,
            workflowFields,
        } = this.props;

        let fieldError;
        if (workflowFields &&
            workflowFields.length > 0 &&
            !workflowFields.find(field => field.label === this.state.field)) {

            fieldError = 'Must Select';
        }

        const noValueOperator = this.state.filter && (this.state.filter.operator === '_' || this.state.filter.operator === '!_');
        let valueError;
        if (!this.state.value) {
            valueError = 'Value Missing';
        }

        let errorStyle = { marginLeft: 5 };
        if (fieldError || valueError) {
            errorStyle = { ...errorStyle };
            if (fieldError && !valueError) {
                valueError = '<- Field Missing';
            } else if (!fieldError && valueError && !noValueOperator) {
                fieldError = '-> Value Missing';
            }
        }

        return (
        <Row>
        <Form>
            <Col xs={12}>
                <Col xs={12} md={5}>
                <AutoComplete field={{
                            name: `field_${rowIndex}`,
                            touched: true,
                            error: fieldError,
                            value: this.state.field,
                            onChange: (value) => {
                                this.onChange('field', value);
                            }
                        }}
                        style={errorStyle}
                        name={`field_${rowIndex}`}
                        returnSelectedObject={true}
                        allowNew={false}
                        options={workflowFields}/>
                </Col>
                <Col xs={12} md={3}>
                <Select field={{
                            name: `operation_${rowIndex}`,
                            value: this.state.operation,
                            onChange: (evt) => {
                                this.onChange('operation', evt.target.value);
                            }
                        }}
                        style={errorStyle}
                        name={`operation_${rowIndex}`}
                        options={comparisonTypes}/>
                </Col>

                {this.state.filter && !noValueOperator && (
                    <Col xs={12} md={3}>
                    <TextInput field={{
                                name: `value_${rowIndex}`,
                                value: this.state.value,
                                touched: true,
                                error: valueError,
                                onChange: (evt) => {
                                    this.onChange('value', evt.target.value);
                                }
                            }}
                            style={errorStyle}
                            name={`value_${rowIndex}`}/>
                    </Col>
                    )}
                <Col xs={3} md={1}>
                <InputGroup>
                    <InputGroup.Button>
                    <Button onClick={deleteAction}
                            block
                            disabled={loading}
                            icon="trash"
                            tooltip="Delete filter"/>
                    </InputGroup.Button>
                    <InputGroup.Button>
                    <Button onClick={addAction}
                            block
                            disabled={loading}
                            icon="plus"
                            iconStyle={{height: "20px"}}
                            tooltip="Add new filter"/>
                    </InputGroup.Button>
                </InputGroup>
                </Col>
            </Col>
        </Form>
        </Row>);
    }
}

FilterSearchField.propTypes = {
    workflowFields: PropTypes.array.isRequired,
    rowIndex: PropTypes.number.isRequired,
    loading: PropTypes.bool,
    deleteAction: PropTypes.func.isRequired,
    addAction: PropTypes.func.isRequired,
    changeAction: PropTypes.func.isRequired,
    filter: PropTypes.object
}

export default FilterSearchField;